<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Password Change"
    maxWidth="500px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="changePasswordForm">
        <v-row>
          <v-col cols="12">
            <v-card-title class="mt-3 py-0 px-0">Password Policy</v-card-title>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-0">
            <ul>
              <li>Must contain at least 8 characters</li>
              <li>Must contain at least one upper case letter</li>
              <li>Must contain at least one lower case letter</li>
              <li>Must contain at least a number</li>
              <li>Must contain at least one special character</li>
            </ul>
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12" v-if="showCurrentPasswordField">
            <PasswordField
              ref="currentPassword"
              label="Current Password"
              :value="currentPassword"
              :is-required="true"
              :is-needed-to-validate="true"
              @valueChange="(newValue) => this.currentPassword = newValue"
            ></PasswordField>
          </v-col>
          <v-col cols="12">
            <PasswordField
              ref="newPassword"
              label="New Password"
              :value="password"
              :is-required="true"
              :is-needed-to-validate="true"
              @valueChange="(newValue) => this.password = newValue"
            ></PasswordField>
          </v-col>
          <v-col cols="12">
            <PasswordConfirmationField
              ref="passwordConfirmation"
              label="Confirm New Password"
              :value="passwordConfirmation"
              :password-to-match="password"
              @valueChange="(newValue) => this.passwordConfirmation = newValue"
            ></PasswordConfirmationField>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="changePasswordHandler"
          >
            Save
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import DynamicModal from '@/components/dialogs/DynamicModal'
import { SimplePageHeader } from '@/components/pageComponents'
import { mapFields } from '@/vueHelpers/vuex'
import { getCurrentUser, userIsAdmin } from '@/lib/authentication'
import { mapActions } from 'vuex'
import { PasswordField, PasswordConfirmationField } from '@/components/shared/textFields/'

export default {
  components: {
    DynamicModal,
    SimplePageHeader,
    PasswordField,
    PasswordConfirmationField
  },
  data () {
    return {
      showModalProp: false,
      passwordConfirmation: null
    }
  },
  props: [
    'userID',
    'showCurrentPasswordField'
  ],
  computed: {
    ...mapFields('userPassword', [
      'password',
      'currentPassword'
    ]),
    id: {
      get () {
        return (this.userID && userIsAdmin()) ? this.userID : getCurrentUser().id
      }
    }
  },
  methods: {
    ...mapActions('userPassword', [
      'saveUserPassword',
      'clearUserPassword'
    ]),
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.clearPassword()
      this.resetPasswordFields()
      this.$refs.changePasswordForm.resetValidation()
      this.showModalProp = false
    },
    async changePasswordHandler () {
      if (this.$refs.changePasswordForm.validate()) {
        await this.saveUserPassword({ id: this.id })
          .then(() => {
            this.$emit('closeDialog')
          })
        this.closeModal()
        this.resetPasswordFields()
      }
    },
    clearPassword () {
      this.clearUserPassword()
      this.passwordConfirmation = null
    },
    resetPasswordFields () {
      if (this.showCurrentPasswordField) {
        this.$refs.currentPassword.reset()
      }
      this.$refs.newPassword.reset()
      this.$refs.passwordConfirmation.reset()
    }
  },
  created () {
    this.clearPassword()
  }
}
</script>
